import { render, staticRenderFns } from "./WBtn.vue?vue&type=template&id=787c9d53&scoped=true&"
import script from "./WBtn.vue?vue&type=script&lang=js&"
export * from "./WBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c9d53",
  null
  
)

export default component.exports